import React from "react";
import UserVisibilityTab from "./UserVisibilityTab";

const AssignVisibilityPage = () => {
  return (
    <div className="container mt-4">
      <h3 className="mb-4">Assign User Visibility</h3>
      <UserVisibilityTab />
    </div>
  );
};

export default AssignVisibilityPage;
